import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getManager = createAsyncThunk(
  "schedule/getManager",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.eventManager(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const getManagerSlice = createSlice({
  name: "getManager",
  initialState,
  reducers: {
    updateReportingDataVal(state, action) {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getManager.pending, (state) => {
        state.loading = true;
      })
      .addCase(getManager.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getManager.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const getManagerList = (state) => state.getManager.value;
export const { updateReportingDataVal } = getManagerSlice.actions;

export default getManagerSlice.reducer;
